export default "__VITE_PUBLIC_ASSET__32742139__"